export const SAVE_USERINFO = 'SAVE_USERINFO'; //保存用户信息
export const MODIFY_USERINFO = 'MODIFY_USERINFO'; //修改用户信息

//保存用户信息
export const saveUserInfo = (userInfo) => {
  return {
    type: SAVE_USERINFO,
    userInfo
  }
}

//修改用户信息
export const modifyUserInfo = (key, value) => {
  return {
    type: MODIFY_USERINFO,
    key,
    value
  }
}